'use client';

import MegaMenu from './mega-menu';
function SubMenu() {
  return <div className='hidden h-11 w-full bg-neutral-800 transition-transform duration-300 lg:flex' data-sentry-component="SubMenu" data-sentry-source-file="sub-menu.tsx">
            <div className='layout-container relative flex items-center justify-start'>
                <MegaMenu data-sentry-element="MegaMenu" data-sentry-source-file="sub-menu.tsx" />
            </div>
        </div>;
}
export default SubMenu;